const hiddenPairsTree = {
  ultraHigh: {
    name: "Ultra High",
    pairs: [
      { tickers: ["V", "MA"], relationship: "payment networks", useCase: "Peer Comparison" },
      { tickers: ["KO", "PEP"], relationship: "beverages", useCase: "Peer Comparison" },
      { tickers: ["XOM", "CVX"], relationship: "oil majors", useCase: "Energy Peer" },
      { tickers: ["HD", "LOW"], relationship: "home improvement", useCase: "Retail Peer" },
      { tickers: ["F", "GM"], relationship: "automakers", useCase: "Auto Peer" },
      { tickers: ["SLB", "HAL"], relationship: "oil services", useCase: "Energy Services" },
      { tickers: ["JPM", "BAC"], relationship: "money center banks", useCase: "Bank Peer" },
      { tickers: ["MS", "GS"], relationship: "investment banks", useCase: "Capital Markets" },
      { tickers: ["PNC", "TFC"], relationship: "regional banks", useCase: "Regional Bank Peer" },
      { tickers: ["DAL", "UAL"], relationship: "airlines", useCase: "Travel Peer" },
      { tickers: ["AAL", "UAL"], relationship: "airlines", useCase: "Travel Peer" },
      { tickers: ["UPS", "FDX"], relationship: "logistics", useCase: "Logistics Peer" },
      { tickers: ["EOG", "COP"], relationship: "E&P oil", useCase: "Oil Producer Peer" },
      { tickers: ["MPC", "VLO"], relationship: "refiners", useCase: "Refiner Peer" },
      { tickers: ["NUE", "STLD"], relationship: "steel producers", useCase: "Steel Peer" },
      { tickers: ["O", "NNN"], relationship: "net lease REITs", useCase: "REIT Peer" },
      { tickers: ["PLD", "DRE"], relationship: "industrial REITs", useCase: "REIT Peer" },
      { tickers: ["CCI", "AMT"], relationship: "cell tower REITs", useCase: "Infrastructure REIT" },
      { tickers: ["BK", "STT"], relationship: "custody banks", useCase: "Custody Bank Peer" },
      { tickers: ["SCHW", "ETFC"], relationship: "brokerage platforms", useCase: "Brokerage Peer" }
    ]
  },

  veryHigh: {
    name: "Core Sector Pairs",
    pairs: [
      { tickers: ["NVDA", "AMD"], relationship: "semiconductors", useCase: "Chip Peer" },
      { tickers: ["JPM", "BAC"], relationship: "banks", useCase: "Bank Peer" },
      { tickers: ["MS", "GS"], relationship: "investment banks", useCase: "Capital Markets" },
      { tickers: ["T", "VZ"], relationship: "telecom", useCase: "Telecom Peer" },
      { tickers: ["MCD", "YUM"], relationship: "fast food", useCase: "Restaurant Peer" },
      { tickers: ["WFC", "C"], relationship: "large banks", useCase: "Bank Peer" },
      { tickers: ["USB", "PNC"], relationship: "regional banks", useCase: "Regional Bank Peer" },
      { tickers: ["AVGO", "QCOM"], relationship: "semiconductors", useCase: "Chip Peer" },
      { tickers: ["TXN", "ADI"], relationship: "analog chips", useCase: "Analog Chip Peer" },
      { tickers: ["LMT", "RTX"], relationship: "defense contractors", useCase: "Defense Peer" },
      { tickers: ["NOC", "LMT"], relationship: "defense contractors", useCase: "Defense Peer" },
      { tickers: ["UNH", "HUM"], relationship: "health insurers", useCase: "Healthcare Peer" },
      { tickers: ["SBUX", "MCD"], relationship: "consumer dining", useCase: "Restaurant Peer" },
      { tickers: ["MAR", "HLT"], relationship: "hotels", useCase: "Travel Peer" },
      { tickers: ["AMT", "CCI"], relationship: "cell tower REITs", useCase: "Infrastructure REIT" },
      { tickers: ["PLD", "PSA"], relationship: "real estate / REITs", useCase: "REIT Peer" },
      { tickers: ["ECL", "LIN"], relationship: "industrial chemicals", useCase: "Chemical Peer" },
      { tickers: ["ADBE", "CRM"], relationship: "enterprise software", useCase: "Software Peer" },
      { tickers: ["INTU", "ADP"], relationship: "financial software", useCase: "Software Peer" },
      { tickers: ["BKNG", "EXPE"], relationship: "online travel", useCase: "Travel Peer" }
    ]
  },

  strong: {
    name: "Strong Business Links",
    pairs: [
      { tickers: ["CAT", "DE"], relationship: "heavy equipment", useCase: "Industrial Peer" },
      { tickers: ["UPS", "FDX"], relationship: "logistics", useCase: "Logistics Peer" },
      { tickers: ["DAL", "UAL"], relationship: "airlines", useCase: "Travel Peer" },
      { tickers: ["AVGO", "QCOM"], relationship: "chips", useCase: "Chip Peer" },
      { tickers: ["NVDA", "AVGO"], relationship: "semiconductors", useCase: "AI Chip Peer" },
      { tickers: ["AMD", "QCOM"], relationship: "semiconductors", useCase: "Chip Peer" },
      { tickers: ["GS", "JPM"], relationship: "financials", useCase: "Financial Peer" },
      { tickers: ["MS", "SCHW"], relationship: "brokerage / wealth", useCase: "Wealth Platform" },
      { tickers: ["COST", "WMT"], relationship: "retail giants", useCase: "Retail Peer" },
      { tickers: ["TGT", "WMT"], relationship: "retail", useCase: "Retail Peer" },
      { tickers: ["NKE", "ADDYY"], relationship: "apparel", useCase: "Apparel Peer" },
      { tickers: ["LULU", "NKE"], relationship: "athletic apparel", useCase: "Apparel Peer" },
      { tickers: ["CMG", "SBUX"], relationship: "consumer dining", useCase: "Restaurant Peer" },
      { tickers: ["BA", "RTX"], relationship: "aerospace", useCase: "Aerospace Peer" },
      { tickers: ["GD", "LMT"], relationship: "defense", useCase: "Defense Peer" },
      { tickers: ["EOG", "SLB"], relationship: "oil & services", useCase: "Energy Chain" },
      { tickers: ["COP", "HAL"], relationship: "oil exposure", useCase: "Energy Chain" },
      { tickers: ["NEE", "SO"], relationship: "utilities", useCase: "Utility Peer" },
      { tickers: ["DUK", "D"], relationship: "utilities", useCase: "Utility Peer" },
      { tickers: ["AMZN", "MSFT"], relationship: "cloud / tech", useCase: "Cloud Peer" },
      { tickers: ["GOOGL", "META"], relationship: "digital advertising", useCase: "Ad Platform Peer" },
      { tickers: ["PLD", "AMT"], relationship: "REITs / infrastructure", useCase: "Infrastructure REIT" },
      { tickers: ["PFE", "MRK"], relationship: "pharma", useCase: "Pharma Peer" },
      { tickers: ["LLY", "NVO"], relationship: "GLP-1 / obesity drugs", useCase: "Drug Theme" },
      { tickers: ["DIS", "NFLX"], relationship: "streaming / media", useCase: "Media Peer" },
      { tickers: ["COIN", "RIOT"], relationship: "crypto exposure", useCase: "Crypto Proxy" }
    ]
  },

  sector: {
    name: "Sector Pairs",
    pairs: [
      { tickers: ["NEE", "DUK"], relationship: "utilities", useCase: "Utility Peer" },
      { tickers: ["SO", "D"], relationship: "utilities", useCase: "Utility Peer" },
      { tickers: ["PFE", "MRK"], relationship: "pharma", useCase: "Pharma Peer" },
      { tickers: ["SPG", "O"], relationship: "REITs", useCase: "REIT Peer" },
      { tickers: ["XOM", "COP"], relationship: "oil & gas", useCase: "Energy Peer" },
      { tickers: ["CVX", "EOG"], relationship: "energy producers", useCase: "Oil Producer Peer" },
      { tickers: ["WMT", "COST"], relationship: "consumer defensive retail", useCase: "Retail Peer" },
      { tickers: ["TGT", "COST"], relationship: "retail", useCase: "Retail Peer" },
      { tickers: ["HD", "TGT"], relationship: "consumer discretionary", useCase: "Consumer Cycle" },
      { tickers: ["LOW", "WMT"], relationship: "retail crossover", useCase: "Retail Crossover" },
      { tickers: ["MSFT", "GOOGL"], relationship: "mega cap tech", useCase: "Mega-Cap Tech" },
      { tickers: ["AAPL", "AMZN"], relationship: "consumer tech", useCase: "Consumer Tech" },
      { tickers: ["NVDA", "TSM"], relationship: "semiconductors", useCase: "Chip Supply Chain" },
      { tickers: ["INTC", "AMD"], relationship: "chipmakers", useCase: "Chip Peer" },
      { tickers: ["JPM", "WFC"], relationship: "banks", useCase: "Bank Peer" },
      { tickers: ["BAC", "C"], relationship: "money center banks", useCase: "Bank Peer" },
      { tickers: ["BLK", "SCHW"], relationship: "asset management", useCase: "Asset Manager Peer" },
      { tickers: ["BA", "GE"], relationship: "industrial / aerospace", useCase: "Aerospace Cycle" },
      { tickers: ["HON", "GE"], relationship: "industrial conglomerates", useCase: "Industrial Peer" },
      { tickers: ["CAT", "HON"], relationship: "industrial cycle", useCase: "Industrial Cycle" },
      { tickers: ["DIS", "CMCSA"], relationship: "media", useCase: "Media Peer" },
      { tickers: ["NFLX", "DIS"], relationship: "streaming/media", useCase: "Media Peer" },
      { tickers: ["SBUX", "MCD"], relationship: "consumer dining", useCase: "Restaurant Peer" },
      { tickers: ["NKE", "CROX"], relationship: "footwear/apparel", useCase: "Apparel Peer" },
      { tickers: ["GM", "TSLA"], relationship: "automotive", useCase: "Auto Peer" },
      { tickers: ["PLD", "SPG"], relationship: "REITs", useCase: "REIT Peer" },
      { tickers: ["AMT", "PLD"], relationship: "real estate infrastructure", useCase: "Infrastructure REIT" },
      { tickers: ["LIN", "APD"], relationship: "industrial gases", useCase: "Chemical Peer" },
      { tickers: ["FCX", "NEM"], relationship: "commodities / mining", useCase: "Commodity Peer" },
      { tickers: ["UAL", "AAL"], relationship: "airlines", useCase: "Travel Peer" }
    ]
  },

  hidden: {
    name: "Hidden / Non-Obvious",
    pairs: [
      { tickers: ["NVDA", "TSM"], relationship: "chip supply chain", useCase: "Supply Chain" },
      { tickers: ["AAPL", "AVGO"], relationship: "supplier relationship", useCase: "Supplier Link" },
      { tickers: ["COIN", "MSTR"], relationship: "bitcoin exposure", useCase: "Crypto Proxy" },
      { tickers: ["RIOT", "MARA"], relationship: "bitcoin miners", useCase: "Crypto Miner Peer" },
      { tickers: ["MSFT", "NVDA"], relationship: "AI ecosystem", useCase: "AI Ecosystem" },
      { tickers: ["AMZN", "UPS"], relationship: "ecommerce logistics dependency", useCase: "Demand Link" },
      { tickers: ["AMZN", "FDX"], relationship: "shipping demand", useCase: "Demand Link" },
      { tickers: ["AAPL", "TSM"], relationship: "chip manufacturing dependency", useCase: "Supply Chain" },
      { tickers: ["TSLA", "ALB"], relationship: "lithium / EV batteries", useCase: "EV Supply Chain" },
      { tickers: ["TSLA", "LAC"], relationship: "lithium supply chain", useCase: "EV Supply Chain" },
      { tickers: ["NVDA", "SMCI"], relationship: "AI server infrastructure", useCase: "AI Infrastructure" },
      { tickers: ["NVDA", "DELL"], relationship: "AI hardware ecosystem", useCase: "AI Infrastructure" },
      { tickers: ["GOOGL", "TTD"], relationship: "digital advertising", useCase: "Ad Tech Link" },
      { tickers: ["META", "TTD"], relationship: "ad tech ecosystem", useCase: "Ad Tech Link" },
      { tickers: ["DIS", "LYV"], relationship: "entertainment demand", useCase: "Demand Link" },
      { tickers: ["SBUX", "PEP"], relationship: "consumer beverage demand", useCase: "Demand Link" },
      { tickers: ["WMT", "KR"], relationship: "grocery demand", useCase: "Grocery Peer" },
      { tickers: ["HD", "SHW"], relationship: "housing / renovation cycle", useCase: "Housing Cycle" },
      { tickers: ["LOW", "SHW"], relationship: "home improvement demand", useCase: "Housing Cycle" },
      { tickers: ["CAT", "FCX"], relationship: "global construction & commodities", useCase: "Commodity Cycle" },
      { tickers: ["XOM", "HAL"], relationship: "oil production + services", useCase: "Energy Chain" },
      { tickers: ["DAL", "BKNG"], relationship: "travel demand", useCase: "Travel Demand" },
      { tickers: ["MAR", "DAL"], relationship: "travel ecosystem", useCase: "Travel Demand" },
      { tickers: ["PYPL", "SQ"], relationship: "digital payments growth", useCase: "Fintech Peer" },
      { tickers: ["MA", "SQ"], relationship: "payments ecosystem", useCase: "Payments Link" },
      { tickers: ["CRM", "NOW"], relationship: "enterprise SaaS", useCase: "Software Peer" },
      { tickers: ["ORCL", "AMZN"], relationship: "cloud infrastructure exposure", useCase: "Cloud Link" },
      { tickers: ["LLY", "DXCM"], relationship: "diabetes / GLP-1 ecosystem", useCase: "Healthcare Link" },
      { tickers: ["UNH", "CI"], relationship: "health insurance + services", useCase: "Healthcare Peer" },
      { tickers: ["PFE", "BMY"], relationship: "drug development pipelines", useCase: "Pharma Peer" },
      { tickers: ["GE", "BA"], relationship: "aerospace supply chain", useCase: "Supply Chain" },
      { tickers: ["HON", "RTX"], relationship: "aerospace components", useCase: "Supply Chain" }
    ]
  },

  macro: {
    name: "Macro-Driven",
    pairs: [
      { tickers: ["XOM", "SLB"], relationship: "oil prices", useCase: "Oil Exposure" },
      { tickers: ["DAL", "UAL"], relationship: "travel demand", useCase: "Travel Demand" },
      { tickers: ["CAT", "FCX"], relationship: "global growth / commodities", useCase: "Commodity Cycle" },
      { tickers: ["NEE", "DUK"], relationship: "interest rates / utilities", useCase: "Rate Sensitive" },
      { tickers: ["COIN", "MSTR"], relationship: "bitcoin exposure", useCase: "Crypto Proxy" },
      { tickers: ["NVDA", "MSFT"], relationship: "AI spending cycle", useCase: "AI Demand" },
      { tickers: ["CVX", "HAL"], relationship: "oil capex cycle", useCase: "Energy Chain" },
      { tickers: ["COP", "EOG"], relationship: "oil prices", useCase: "Oil Exposure" },
      { tickers: ["BA", "GE"], relationship: "global travel recovery", useCase: "Travel Cycle" },
      { tickers: ["MAR", "HLT"], relationship: "travel demand", useCase: "Travel Demand" },
      { tickers: ["HD", "LOW"], relationship: "housing cycle / rates", useCase: "Housing Cycle" },
      { tickers: ["DHI", "LEN"], relationship: "homebuilding / mortgage rates", useCase: "Rate Sensitive" },
      { tickers: ["SPG", "O"], relationship: "interest rates / REITs", useCase: "Rate Sensitive" },
      { tickers: ["AMT", "CCI"], relationship: "rates / yield sensitivity", useCase: "Rate Sensitive" },
      { tickers: ["WMT", "COST"], relationship: "consumer spending", useCase: "Consumer Spending" },
      { tickers: ["TGT", "WMT"], relationship: "consumer demand", useCase: "Consumer Demand" },
      { tickers: ["MCD", "SBUX"], relationship: "consumer discretionary spending", useCase: "Consumer Spending" },
      { tickers: ["JPM", "BAC"], relationship: "credit cycle / rates", useCase: "Credit Cycle" },
      { tickers: ["MS", "GS"], relationship: "capital markets activity", useCase: "Market Cycle" },
      { tickers: ["BLK", "SCHW"], relationship: "equity market flows", useCase: "Market Cycle" },
      { tickers: ["NVDA", "AVGO"], relationship: "AI demand / semis", useCase: "AI Demand" },
      { tickers: ["AMD", "NVDA"], relationship: "AI chip demand", useCase: "AI Demand" },
      { tickers: ["TSLA", "GM"], relationship: "auto demand / rates", useCase: "Auto Cycle" },
      { tickers: ["FCX", "BHP"], relationship: "commodity cycle / China demand", useCase: "Commodity Cycle" },
      { tickers: ["LIN", "APD"], relationship: "industrial production", useCase: "Industrial Cycle" },
      { tickers: ["NEM", "GOLD"], relationship: "gold / inflation hedge", useCase: "Gold Exposure" },
      { tickers: ["UAL", "AAL"], relationship: "fuel costs + travel demand", useCase: "Travel Cycle" },
      { tickers: ["PYPL", "SQ"], relationship: "consumer spending / fintech", useCase: "Fintech Cycle" },
      { tickers: ["ADBE", "CRM"], relationship: "enterprise tech spending", useCase: "Software Cycle" },
      { tickers: ["ORCL", "AMZN"], relationship: "cloud demand cycle", useCase: "Cloud Cycle" },
      { tickers: ["LLY", "NVO"], relationship: "healthcare demand / GLP-1", useCase: "Healthcare Theme" }
    ]
  }
};

export default hiddenPairsTree;